import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Form, FormArray, AbstractControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { isString, sortBy, uniqWith } from 'lodash';
import { Observer, Subscription, forkJoin, pipe, map, Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { CheckboxListValidators } from 'src/app/CustomValidators/CheckboxListValidators';
import { BeachSite } from 'src/app/models/BeachSite';
import { Council, Region,getBeachSitesInArea, isSubRegion } from 'src/app/models/SiteGroups';
import { DownloadDataService } from 'src/app/services/download-data/download-data.service';
import { ListService } from 'src/app/services/list.service';
import { SitesService } from 'src/app/services/sites.service';
import { LOOKUP_AREA_TYPES } from 'src/app/models/lookupAreaTypes';
import { RegionCouncilBeachSitesSelectionComponent } from '../region-council-beach-sites-selection/region-council-beach-sites-selection.component';
import { CustomDateWidgetComponent } from 'src/app/shared/custom-date-widget/custom-date-widget.component';
import { parseISO  } from 'date-fns';

import { DownloadDataError, isDownloadDataError } from 'src/app/models/DownloadData/DownloadDataError';
import { DownloadLabResultsDataModel, DownloadLabResultsRequestModel } from 'src/app/models/DownloadData/DownloadLabResultsData';
import { ColumnDefinition, TableDefinition } from '../datatable/datatable.component';
import { DialogRef } from 'src/app/shared/CustomDialog/DialogRef';
import { UserFeedbackDialogComponent } from 'src/app/shared/user-feedback-dialog/user-feedback-dialog.component';
import { DialogService } from 'src/app/shared/CustomDialog/DialogService';
import { DownloadAnnualgradeRequestDataModel, DownloadAnnualgradesDataModel } from 'src/app/models/DownloadData/DownloadAnnualgradesData';
import { formatDate } from '@angular/common';
import { DOWNLOAD_DATA_CONDUCTIVITY_COLUMNNAME, DOWNLOAD_DATA_COORDINATES_COLUMNNAME, DOWNLOAD_DATA_DATE_FORMAT, DOWNLOAD_DATA_ENTEROCOCCI_COLUMNNAME, DOWNLOAD_DATA_LATITUDE_COLUMNNAME, DOWNLOAD_DATA_LONGITUDE_COLUMNNAME, DOWNLOAD_DATA_WATERTEMP_COLUMNNAME, FORMAT_DATE_LOCALE, REGEX_DECIMAL, TREND_EXPORT_DATA_DATE_FORMAT } from 'src/app/models/app-constants';
import { ActivatedRoute } from '@angular/router';
import { CounterDirective } from 'src/app/shared/directives/counter.directive';
import { downloadData } from 'src/app/shared/DomUtils';
import { UserFeedbackModalDialogComponent } from 'src/app/shared/custom-modal-dialog/user-feedback-modal-dialog/user-feedback-modal-dialog.component';
import { formatDateAEST } from 'src/app/shared/utils';
import { AppMonitoringService } from 'src/app/services/logging.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	  const isSubmitted = form && form.submitted;
	  return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
  }

  
type KeyValueItem = { [key : string] : any };
const decimalRegExValidator = new RegExp(REGEX_DECIMAL, "i");


const validKeys = [
	"ArrowLeft", "ArrowRight", "Backspace", "Delete"	
];

@Component({
	selector: 'app-water-quality-data',
	templateUrl: './water-quality-data.component.html',
	styleUrls: ['./water-quality-data.component.scss']
})
export class WaterQualityDataComponent implements OnInit, OnDestroy {


	@ViewChild(RegionCouncilBeachSitesSelectionComponent) regionCouncilBeachSiteSelector : RegionCouncilBeachSitesSelectionComponent;
	@ViewChild("fromDate") fromDate : CustomDateWidgetComponent;
	@ViewChild("toDate") toDate : CustomDateWidgetComponent;

	public selectedCouncil : string = "";

	public DOWNLOAD_DATATYPES : string[] = ["Water quality", "Annual grade"];	
	public DATA_CATEGORIES : string[] = ["Enterococci", "Water temperature", "Conductivity"];

	//public allRegions$ : BehaviorSubject<Region[]> = new  BehaviorSubject<Region[]>([]);
	//public allCouncils$ : BehaviorSubject<Council[]> = new  BehaviorSubject<Council[]>([]);
	//public allBeachSites$ : BehaviorSubject<BeachSite[]> = new  BehaviorSubject<BeachSite[]>([]);
	

	public allRegions : Region[] = [];
	public allCouncils : Council[] = [];
	public allBeachSites : BeachSite[] = [];
	private apiRequestsSub : Subscription;
	private apiRequestCountSub : Subscription;

	public noData = false;

	public annualgradeYears : number[] = [];
	public fromDateToDateError : { error : boolean; message : string } = { error : false, message : ""};
	public FILTER_BY = [LOOKUP_AREA_TYPES.Region, LOOKUP_AREA_TYPES.Council, LOOKUP_AREA_TYPES.BeachSite];
	areaLookupTypes = LOOKUP_AREA_TYPES;	

	public viewData : boolean = false;	
	tableDefinition : TableDefinition = { columns : [], rows : [], pagination : { enabled : true, pageSizes : [5, 10, 25, 50 ]}};
	popupDialogRef : DialogRef;		
	downloadDataPayload : DownloadAnnualgradeRequestDataModel | DownloadLabResultsRequestModel | undefined;
	private selectedDataType : string = "";
	private nextDownloadDatatypeChange : string = ""
	private suppressDatatypeChangeWarning : boolean = false;
	private handle : Subscription;
	
	public dialogData : any = null;
	public showDialog : boolean = false;
	public processing : boolean = false;

	private annualgradesDataColumns : ColumnDefinition[] = [
		{ id : 0, label : "Id", name : "Id", dataType : "string", hidden : true },
		{ id : 1, label : "Region", name : "Region", dataType : "string" },
		{ id : 2, label : "Council", name : "Council", dataType : "string" },
		{ id : 3, label : "Swim site", name : "Swim site", dataType : "string" },
		{ id : 4, label : "Year", name : "Year", dataType : "number" },
		{ id : 5, label : "Annual grade", name : "Annual grade", dataType : "string" },
		{ id : 6, label : DOWNLOAD_DATA_COORDINATES_COLUMNNAME, name : DOWNLOAD_DATA_COORDINATES_COLUMNNAME, dataType : "number", renderData : this.renderData }
	];

	private labResultsDatacolumns : ColumnDefinition[] = [
		{ id : 0, label : "Id", name : "Id", dataType : "string", hidden : true },
		{ id : 1, label : "Region", name : "Region", dataType : "string" },
		{ id : 2, label : "Council", name : "Council", dataType : "string" },
		{ id : 3, label : "Swim site", name : "Swim site", dataType : "string" },
		{ id : 4, label : "Date", name : "Date", dataType : "Date", renderData : this.renderData  },
		{ id : 5, label : DOWNLOAD_DATA_ENTEROCOCCI_COLUMNNAME, name : DOWNLOAD_DATA_ENTEROCOCCI_COLUMNNAME, dataType : "number", hidden : true },
		{ id : 6, label : DOWNLOAD_DATA_WATERTEMP_COLUMNNAME, name : DOWNLOAD_DATA_WATERTEMP_COLUMNNAME, dataType : "number", hidden : true },
		{ id : 7, label : DOWNLOAD_DATA_CONDUCTIVITY_COLUMNNAME, name : DOWNLOAD_DATA_CONDUCTIVITY_COLUMNNAME, dataType : "number", hidden : true },
		{ id : 8, label : DOWNLOAD_DATA_COORDINATES_COLUMNNAME, name : DOWNLOAD_DATA_COORDINATES_COLUMNNAME, dataType : "number", renderData : this.renderData }		
	];

	downloadDataForm = this.fb.group({
		downloadDatatype : this.fb.control('', Validators.required),		
		regionsArray : this.fb.array([]),
		councilsArray : this.fb.array([]),
		beachSitesArray : this.fb.array([]),		
		downloadDataCategories : this.fb.array([this.fb.control(false), this.fb.control(false), this.fb.control(false)]),
		selectedYears : this.fb.array([])
	});	


	constructor(private fb : FormBuilder,		
		private sitesService : SitesService,
		private listService : ListService,
		private downloadDataService : DownloadDataService,		
		private userfeedbackModalDlg : UserFeedbackModalDialogComponent,
		private activatedRoute : ActivatedRoute,private monitoringService: AppMonitoringService) 
	{

	}	
	
	ngOnInit(): void {		

		this.apiRequestsSub = combineLatest([
			this.sitesService.getDownloadDataSitesList(), 
			this.listService.getRegionList(),
			this.listService.getCouncilList()]).subscribe(
			{
				next : (data) => {
					if(Array.isArray(data) && 3 === data?.length)
					{
						const beachSites = Array.isArray(data[0]) ? data[0] : [];
						this.allBeachSites = uniqWith(beachSites, (a : BeachSite, b : BeachSite) => {
							return a.Identifier === b.Identifier;
						});
						
						//this.allBeachSites$.next(beachSites);
						if(Array.isArray(data[1]))
						{
							const tmpRegions = uniqWith(data[1], (regionA : Region, regionB : Region) => {
								return regionA.RegionId === regionB.RegionId;
							});
							//const regions = tmpRegions?.
							//filter((a : Region) => {
							//	return isSubRegion(a);	
							//})?.
							const regions = tmpRegions?.map((region: Region) => {
								const regionBeachSites = getBeachSitesInArea(this.allBeachSites, tmpRegions, region);
																
								return { ...region, Sites: regionBeachSites };
							})?.filter((region : Region) => {						
								return 0 < region.Sites?.length;
							})?.sort((a : any, b : any) => a.RegionName?.localeCompare(b.RegionName));	
							this.allRegions = regions;
						}
						else
						{
							this.allRegions = [];
						}
						//this.allRegions$.next(regions);

						if(Array.isArray(data[1]))
						{
							const tmpCouncils = uniqWith(data[2], (councilA : Council, councilB : Council) => {
								return councilA.CouncilId === councilB.CouncilId;							
							});
							
							const councils = tmpCouncils?.map((council: Council) => {							
								return { ...council, Sites: getBeachSitesInArea(this.allBeachSites, data[1], council, true) };
							}).filter((council : Council) => 0 < council.Sites?.length)?.sort((a : any, b : any) => a.CouncilName?.localeCompare(b.CouncilName));						
							this.allCouncils = councils;
						}
						else
						{
							this.allCouncils = [];
						}
						
						//this.allCouncils$.next(councils);
					}
			},
			error : (error : Error) => {
				console.log(error);
			},
			complete : () => {
				
			}
		});	

		const thisYear = new Date().getFullYear();
		const minYear = 2006;
		this.selectedYears?.clear();
		for(let i = thisYear; i >= minYear; --i)
		{
			this.annualgradeYears.push(i);			
		}

		this.createAnnualGradeYearsControls();
		this.downloadDatatype?.valueChanges?.subscribe({
			next : (data) => {	
				if(data !== "" && data === this.selectedDataType)
				{
					return;
				}	
				if(!!data && this.formHasSelections(this.selectedDataType)) 				
				{
					this.nextDownloadDatatypeChange = data ?? "";
					this.downloadDatatype?.patchValue(this.selectedDataType, { emitEvent : true });
					this.showDatatypeChangeDialog();
					return;
				}					

				this.selectedDataType = data ?? "";
				this.reset();

				if(this.DOWNLOAD_DATATYPES[1] === data)
				{	
					this.createAnnualGradeYearsControls();				
					this.selectedYears?.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());						
					this.downloadDataCategories.clearValidators();
				}
				else if(this.DOWNLOAD_DATATYPES[0] === data)
				{					
					this.selectedYears?.clearValidators();
					this.downloadDataCategories.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());
				}
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		});
		
		this.handle = this.activatedRoute.queryParams.subscribe({
			next : (params : any) => 
			{		
				// this is set on the partner details page explore data for partner button at the bottom of partner details page		
				this.selectedCouncil = params.partnerName ?? "";			
			},
			error : (ex : Error) => {

			},
			complete : () => {

		}});		
		
	}
	
	private formHasSelections = (dataType : string) => {
		const regionCouncilDirty = this.regionCouncilBeachSiteSelector?.dirty;
		const dirty = regionCouncilDirty || 			
			(this.DOWNLOAD_DATATYPES[0] === dataType && ((this.downloadDataCategories?.controls?.some((ctrl : AbstractControl) => !!ctrl.value)) || this.fromDate?.dirty || this.toDate.dirty)) ||
			(this.DOWNLOAD_DATATYPES[1] === dataType && (this.selectedYears?.controls?.some((ctrl) => !!ctrl.value)));
			

		return dirty;
	}	

	showDatatypeChangeDialog = () =>  {
		if(this.suppressDatatypeChangeWarning) 
		{
			return;
		}

		this.showFeedbackDialog({
			data : 
			{ 
				title : "Change the type of data to " + this.nextDownloadDatatypeChange,
				content : `You are attempting to change filtering options while selections have been made from the lists below. If you choose to proceed, all filters will be removed.`,					
				acceptButtonText : "Clear all filters",
				cancelButtonText : "Cancel",
				showCancelButton : true,
				acceptClicked : this.onAcceptDownloadDatatypeChange,
				cancelClicked : this.onCancelDownloadDatatypeChange
			}
		});	
	}

	private onAcceptDownloadDatatypeChange = () => {
		this.hideFeedbackDialog();
		this.noData = false;
		this.regionCouncilBeachSiteSelector?.reset();
		this.fromDate?.reset();
		this.toDate?.reset();
		this.downloadDataCategories?.reset();
		this.selectedYears?.controls?.forEach((ctrl : AbstractControl) => ctrl.reset(false));
		this.downloadDatatype?.setValue(this.nextDownloadDatatypeChange);
		this.nextDownloadDatatypeChange = "";			
		if(this.selectedCouncil)	
		{
			this.regionCouncilBeachSiteSelector?.setCouncil(this.selectedCouncil);
		}
		
	}

	private onCancelDownloadDatatypeChange = () => {
		this.hideFeedbackDialog();
		this.nextDownloadDatatypeChange = "";
		this.downloadDatatype?.patchValue(this.selectedDataType);
	}


	private createAnnualGradeYearsControls = () =>
	{		
		this.selectedYears?.clear();
		this.annualgradeYears.forEach((year : number) => {
			this.selectedYears?.push(this.fb.control(false));
			this.selectedYears?.reset(false);
		});		
		
	}
	
	ngOnDestroy(): void {
		this.apiRequestsSub && this.apiRequestsSub?.unsubscribe();
		this.handle && this.handle?.unsubscribe();
		this.apiRequestCountSub && this.apiRequestCountSub?.unsubscribe();
	}

	public getFormControl = (name : string) : any => {
		return this.downloadDataForm.get(name);
	}

	get downloadDatatype() {
		return this.getFormControl("downloadDatatype") as FormControl;
	}
	
	get downloadDataCategories() {
		return this.getFormControl("downloadDataCategories") as FormArray;
	}

	get selectedYears() {
		return this.getFormControl("selectedYears") as FormArray;
	}	
	

	
	toFormControl(ctrl : any) {
		return ctrl as FormControl;
	}	

	onUpdateFreqSelectedYearChange = (event : any) => {
		
	}
	
	private compareOnlyDate = (dt1 : Date, dt2 : Date) => {
		const date1 = new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());
		const date2 = new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());

		const timeStamp1 = date1.getTime(), timeStamp2 = date2.getTime();
		return timeStamp1 < timeStamp2 ? -1 : timeStamp1 > timeStamp2 ? 1 : 0;
	}

	onDateChanged = (event : any) => {
		const fromDateValid = this.fromDate.isValid();
		const toDateValid = this.fromDate.isValid();

		const fromDt = this.fromDate?.getValue() ? parseISO(this.fromDate?.getValue()!.toString()) : undefined;
		const toDt = this.toDate?.getValue() ? parseISO(this.toDate?.getValue()!.toString()) : null;
		if(null != fromDt && "function" === typeof(fromDt.getTime) && 
			this.compareOnlyDate(fromDt, new Date()) === 1)			
		{
			this.fromDateToDateError = { error : true, message : "'From date' cannot be in the future." };
			return;
		}
		if(null != toDt && "function" === typeof(toDt.getTime) && 
			this.compareOnlyDate(toDt, new Date()) === 1)			
		{
			this.fromDateToDateError = { error : true, message : "'To date' cannot be in the future." };
			return;
		}
		
		if(null != fromDt && null != toDt && 
			"function" === typeof(fromDt.getTime) && "function" === typeof(toDt.getTime) && 
			this.compareOnlyDate(fromDt, toDt) === 1)
		{			
			this.fromDateToDateError = { error : true, message : "'From date' must be less than or equal to 'To date'." };
		}		
		else
		{
			this.fromDateToDateError = { error : false, message : "" };
		}
	}
	
	public clearAllSelectedYears = (reset = true) => {
		this.selectedYears?.controls?.forEach((ctrl : AbstractControl) => {
			reset ? (<FormControl>ctrl).reset() : (<FormControl>ctrl).patchValue(false) ;
		});
	}

	public selectAllYears = () => {
		this.selectedYears?.controls?.forEach((ctrl : AbstractControl) => {
			(<FormControl>ctrl).setValue(true);
		});
	}	

	private reset = () => {
		this.noData = false;
		this.suppressDatatypeChangeWarning = true;
		/* invoke reset on the region council selector so that the pop-up dialog is not shown on reset */		
		this.regionCouncilBeachSiteSelector?.reset();		
		this.downloadDataCategories?.reset();			
		this.selectedYears?.reset();
		this.fromDate?.reset();
		this.toDate?.reset();
		this.fromDateToDateError = { error : false, message : "" };
					
		this.viewData = false;
		this.resetResultsTable();
		this.downloadDataPayload = undefined;
		this.suppressDatatypeChangeWarning = false;
	}
	

	public clearAllFilters = (resetDownloadType = true) => {
		this.suppressDatatypeChangeWarning = true;
		this.reset();	

		this.selectedDataType = "";
		this.nextDownloadDatatypeChange = "";		
		resetDownloadType && this.downloadDatatype?.reset();
			
		this.suppressDatatypeChangeWarning = false;
	}
	
	private resetResultsTable = () => {
		this.viewData = false;		
		this.tableDefinition = { columns : [], rows : [], pagination : { enabled : true, pageSizes : [5, 10, 25, 50 ]}};
	}	

	private renderData(row : any, col : ColumnDefinition)
	{
		let value = "";
		if(col?.dataType === "Date")
		{
			value = !!row?.[col.name]?.toString() ? formatDateAEST(row?.[col.name]?.toString(), 
				DOWNLOAD_DATA_DATE_FORMAT, FORMAT_DATE_LOCALE) : ""
		}
		if(col?.name === DOWNLOAD_DATA_COORDINATES_COLUMNNAME) 
		{
			
			const latLng = [
				decimalRegExValidator.test(row[DOWNLOAD_DATA_LATITUDE_COLUMNNAME]) ? row[DOWNLOAD_DATA_LATITUDE_COLUMNNAME]?.toString() : "",
				decimalRegExValidator.test(row[DOWNLOAD_DATA_LONGITUDE_COLUMNNAME]) ? row[DOWNLOAD_DATA_LONGITUDE_COLUMNNAME]?.toString() : ""
			];

			value = latLng.filter(Boolean).join(",");
		}		

		return value;
	}	

	private setColumnDisplay = (tableDef : TableDefinition, columnName : string, hidden : boolean = false) => {
		const column = tableDef.columns.find((col) => col.name === columnName);
		if(column)
		{
			column.hidden = hidden;

		}
	}

	private executeDownloadData = (asTextOrCSV = false, callbackFn : (data : any) => void) => {
		let apiRequest;				

		const { sites, regions, councils } = this.regionCouncilBeachSiteSelector.getSelectedBeachSites("Identifier", "RegionId", "CouncilId");

		if(this.DOWNLOAD_DATATYPES[0] === this.downloadDatatype?.value)
		{				
			this.tableDefinition.columns = [...this.labResultsDatacolumns];

			this.setColumnDisplay(this.tableDefinition, DOWNLOAD_DATA_ENTEROCOCCI_COLUMNNAME, 
				!this.downloadDataCategories?.controls?.[0].value);			
			
			this.setColumnDisplay(this.tableDefinition, DOWNLOAD_DATA_WATERTEMP_COLUMNNAME, 
				!this.downloadDataCategories?.controls?.[1].value);

			this.setColumnDisplay(this.tableDefinition, DOWNLOAD_DATA_CONDUCTIVITY_COLUMNNAME, 
				!this.downloadDataCategories?.controls?.[2].value);

			this.downloadDataPayload = {			
				// regions : regions,
				// councils : councils,
				sites : sites, 
				include_enterococci : !!this.downloadDataCategories?.controls?.[0].value,
				include_water_temp : !!this.downloadDataCategories?.controls?.[1].value,
				include_conductivity : !!this.downloadDataCategories?.controls?.[2].value,
				start_date : this.fromDate?.getValue() ?? undefined,
				end_date : this.toDate?.getValue() ?? undefined
			};
			
			this.apiRequestCountSub = this.downloadDataService.getLabResultsDataCount(this.downloadDataPayload).subscribe({
				next: (response: any) => {
					if(response.count == 0)
					{
						this.noData = true;
						this.processing = false;
					}
					else
					{						
						this.noData = false;						
						if(this.downloadDataPayload?.sites?.length)
						{
							const sub = this.downloadDataService.downloadLabResultsData(<DownloadLabResultsRequestModel>this.downloadDataPayload, asTextOrCSV).subscribe({
								next : (response : any) => {
									// if("error" in response)
									// {
									// 	this.processing = false;
									// 	alert(response.error);	
									// 	return;									
									// }	
									if(response)
									{	
										if(!this.isErrorResponse(response))
										{
											callbackFn(response);
										}							
									}
								},
								error : (ex : Error) => {
									if(ex)
									{
										alert(ex?.message)
									}									
								},
								complete : () => 
								{										
									sub && sub?.unsubscribe();
									this.processing = false;
								}
							});							
						}
					}
				},
				error(ex: any) { console.log(ex); },
				complete : () => 
				{	
					this.apiRequestCountSub && this.apiRequestCountSub?.unsubscribe();	
				}
			});
					
		}
		else if(this.DOWNLOAD_DATATYPES[1] === this.downloadDatatype?.value)
		{				
			this.tableDefinition.columns = this.annualgradesDataColumns;
			this.downloadDataPayload = {
				//regions : regions,
				//councils : councils,
				sites : sites,
				years : this.annualgradeYears.filter((year : number, idx : number) => 
				{
					return this.selectedYears?.controls?.[idx]?.value;
				})
			};	
			
			
			this.apiRequestCountSub = this.downloadDataService.getAnnualgradesDataCount(this.downloadDataPayload).subscribe({
				next: (response: any) => {
					if(response.count == 0)
					{
						this.noData = true;
						this.processing = false;
					}
					else{
						this.downloadDataPayload = {
							//regions : regions,
							//councils : councils,
							sites : sites,
							years : this.annualgradeYears.filter((year : number, idx : number) => {
								return this.selectedYears?.controls?.[idx]?.value;
							})				
						};	
						this.noData = false;
						
						if(this.downloadDataPayload?.sites?.length)
						{	
							const sub = this.downloadDataService.downloadAnnualgradesData(this.downloadDataPayload, asTextOrCSV).subscribe({
								next : (response : any) => {
									// if("error" in response)
									// {
									// 	alert(response.error);
									// 	this.processing = false;
									// 	return;
									// }	
									if(response)
									{										
										if(!this.isErrorResponse(response))
										{											
											callbackFn(response);
										}
									}															
								},
								error : (ex : Error) => 
								{
									if(ex)
									{
										alert(ex?.message)
									}										
								},
								complete : () => 
								{	
									sub && sub?.unsubscribe();									
									this.processing = false;										
								}
							});
						}
					}
				},
				error(ex: any) { console.log(ex); },
				complete : () => 
				{
					this.apiRequestCountSub && this.apiRequestCountSub?.unsubscribe();
				}
			})
		}
	}

	private isErrorResponse = (response : any) => {
		try
		{
			if("error" in response)
			{
				alert("Request failed");
				return true;
			}
			const jsonResp = JSON.parse(response);
			if(jsonResp?.message)
			{
				alert(jsonResp?.message);
				return true;
			}			
		}
		catch(ex:any)
		{											
		}			
		return false;
	}

	private displayData = (data : DownloadDataError | (DownloadAnnualgradesDataModel | DownloadLabResultsDataModel)[]) => {
		if(Array.isArray(data))
		{			
			this.viewData = true;
			this.tableDefinition.rows = data?.map((row : any) => ({...row }));
		}
		else if(isDownloadDataError(data) && data.numberOfResults)
		{
			this.showDownloadDataConfirmDialog();
		}
		this.processing = false;
	}

	public onViewDataClicked = () => {
		this.viewData = false;
		this.resetResultsTable();
		this.processing = true;
		this.executeDownloadData(false, this.displayData);		
	}

	private formatWaterQualityData = (inData : string) => {
		let outData = inData ?? "";
		if(!inData)
		{
			return outData;
		}
		const DATE_FIELD = "Date";
		const TIME_FIELD = "Time";
		try
		{		
			const linesOfText = inData?.toString()?.trim()?.split(/\r?\n/);
			if(Array.isArray(linesOfText) && 1 < linesOfText.length)
			{			
				const headerParts = linesOfText[0].split(",");
				const dateIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() === DATE_FIELD.toLocaleLowerCase());
				const timeIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() === TIME_FIELD.toLocaleLowerCase());

				const latIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() === DOWNLOAD_DATA_LATITUDE_COLUMNNAME.toLocaleLowerCase());
				const lngIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() === DOWNLOAD_DATA_LONGITUDE_COLUMNNAME.toLocaleLowerCase());
				
				if(-1 < dateIdx)
				{					
					outData = "";				
					const outItem : KeyValueItem [] = [];

					const sortedLines = [];
					for(let i = 1; i < linesOfText.length; ++i)
					{
						const item = linesOfText[i];
						if("" === item?.toString()?.trim())
						{
							continue;
						}						
						const parts = item.split(",");
						const obj : KeyValueItem = {};
						

						for(let j = 0; j < parts.length; ++j)
						{	
							if(j === dateIdx)
							{
								try
								{
									const dt = new Date(Date.parse(parts[j]));
									if(dt && "Invalid Date" !== dt?.toString() && 
										"function" === typeof(dt?.getTime))
									{		
										if(-1 < timeIdx)
										{
											const timeParts = parts[timeIdx]?.split(":");
											if(Array.isArray(timeParts) && 3 === timeParts?.length)
											{
												const dtTime = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 
													Number(timeParts[0]), Number(timeParts[1]), Number(timeParts[2]));	
												obj[DATE_FIELD] = dtTime;
											}
											else
											{
												obj[DATE_FIELD] = dt;
											}
										}										
									}										
								}
								catch(ex)
								{	
									
								}									
							}
							else
							{
								if((!this.downloadDataCategories?.controls?.[0].value && 
										headerParts[j]?.toLocaleLowerCase() === DOWNLOAD_DATA_ENTEROCOCCI_COLUMNNAME?.toLocaleLowerCase()) || 
									(!this.downloadDataCategories?.controls?.[1].value && 
										headerParts[j]?.toLocaleLowerCase() === DOWNLOAD_DATA_WATERTEMP_COLUMNNAME?.toLocaleLowerCase()) ||
									(!this.downloadDataCategories?.controls?.[2].value && 
										headerParts[j]?.toLocaleLowerCase() === DOWNLOAD_DATA_CONDUCTIVITY_COLUMNNAME?.toLocaleLowerCase())
										|| DOWNLOAD_DATA_LONGITUDE_COLUMNNAME?.toLocaleLowerCase() === headerParts[j]?.toLocaleLowerCase())
								{
									continue;
								}

								if(DOWNLOAD_DATA_LATITUDE_COLUMNNAME?.toLocaleLowerCase() === headerParts[j]?.toLocaleLowerCase() && 
									-1 < lngIdx)
								{									
									obj[DOWNLOAD_DATA_COORDINATES_COLUMNNAME] = `${parts[j]} ${parts[lngIdx]}`;
								}
								else
								{
									obj[headerParts[j]] = parts[j];
								}								
							}
						}

						sortedLines.push(obj);
					}
					
					sortedLines.sort((a : any, b : any) => {	
						if(b[DATE_FIELD] && "Invalid Date" !== b[DATE_FIELD]?.toString() && 
							"function" === typeof(b[DATE_FIELD]?.getTime) && 
							a[DATE_FIELD] && "Invalid Date" !== a[DATE_FIELD]?.toString() && 
							"function" === typeof(a[DATE_FIELD]?.getTime))
						{											
							return b[DATE_FIELD]?.getTime() - a[DATE_FIELD]?.getTime();
						}				
						else
						{
							return ('' + b[DATE_FIELD]?.toString()).localeCompare(a[DATE_FIELD]?.toString());
						}
					})
					const newLinesOfText = sortedLines.map((item : any) => {					
						const newItem = { ...item };
						
						if(item[DATE_FIELD] && "Invalid Date" !== item[DATE_FIELD]?.toString() && 
							"function" === typeof(item[DATE_FIELD]?.getTime))
						{											
							newItem[DATE_FIELD] = formatDateAEST(item[DATE_FIELD], DOWNLOAD_DATA_DATE_FORMAT, FORMAT_DATE_LOCALE);									
						}
						return newItem;					
					}).map((item : any) => {
						return Object.values(item).join(",");
					}).filter(Boolean);
					
					headerParts.splice(latIdx, 1);
					const newLngIdx = headerParts.findIndex((a) => a.toLocaleLowerCase() === DOWNLOAD_DATA_LONGITUDE_COLUMNNAME?.toLocaleLowerCase());
					headerParts.splice(newLngIdx, 1, DOWNLOAD_DATA_COORDINATES_COLUMNNAME);

					newLinesOfText.unshift(headerParts.join(","));
					outData = newLinesOfText.join("\r\n");
				}
			}	
		}
		catch(ex : any)
		{
			alert(ex?.message);
		}

		return outData;
	}

	private formatAnnualGradeData = (inData : string) => {
		let outData = inData ?? "";
		if(!inData)
		{
			return outData;
		}

		try
		{
			const YEAR_FIELD = "Year";
			const linesOfText = inData?.toString()?.trim()?.split(/\r?\n/);
			if(Array.isArray(linesOfText) && 1 < linesOfText.length)
			{			
				const headerParts = linesOfText[0].split(",");
				const dateIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() ===  YEAR_FIELD.toLocaleLowerCase());
				const latIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() === DOWNLOAD_DATA_LATITUDE_COLUMNNAME.toLocaleLowerCase());
				const lngIdx = headerParts?.findIndex((a) => a?.toString()?.toLocaleLowerCase() === DOWNLOAD_DATA_LONGITUDE_COLUMNNAME.toLocaleLowerCase());
				
				if(-1 < dateIdx)
				{
					outData = "";						
					const items : KeyValueItem[] = [];
					const sortedLines = [];
					for(let i = 1; i < linesOfText.length; ++i)
					{
						const item = linesOfText[i];
						if("" === item?.toString()?.trim())
						{
							continue;
						}
						const parts = item.split(",");							
						const str = [];
						const obj : KeyValueItem = {};

						for(let j = 0; j < parts.length; ++j)
						{		
							if(DOWNLOAD_DATA_LONGITUDE_COLUMNNAME?.toLocaleLowerCase() === headerParts[j]?.toLocaleLowerCase() && 
								-1 < lngIdx)
							{									
								continue;
							}
							else if(DOWNLOAD_DATA_LATITUDE_COLUMNNAME?.toLocaleLowerCase() === headerParts[j]?.toLocaleLowerCase() && 
								-1 < lngIdx)
							{
								obj[DOWNLOAD_DATA_COORDINATES_COLUMNNAME] = `${parts[j]} ${parts[lngIdx]}`;
							}
							else
							{
								obj[headerParts[j]] = parts[j];
							}													
						}
						sortedLines.push(obj);						
					}
					sortedLines.sort((a : any, b : any) => {	
						return b[YEAR_FIELD] - a[YEAR_FIELD];					
					});
					const newLinesOfText = sortedLines.map((item : any) => {
						return Object.values(item).join(",");
					}).filter(Boolean);				

					headerParts.splice(latIdx, 1);
					const newLngIdx = headerParts.findIndex((a) => a.toLocaleLowerCase() === DOWNLOAD_DATA_LONGITUDE_COLUMNNAME?.toLocaleLowerCase());
					headerParts.splice(newLngIdx, 1, DOWNLOAD_DATA_COORDINATES_COLUMNNAME);
					newLinesOfText.unshift(headerParts.join(","));
					outData = newLinesOfText.join("\r\n");
				}
			}	
		}
		catch(ex : any)
		{
			alert(ex?.message);
		}

		return outData;
	}


	public onDownloadDataClicked = () => {
		this.processing = true;		
		try
		{
			this.executeDownloadData(true, (downloadedData : any) => {
				if(downloadedData)
				{
					let data = downloadedData;
					if(this.DOWNLOAD_DATATYPES[0] === this.downloadDatatype?.value)
					{
						this.monitoringService.logEvent('DownloadWaterQualityData',{'parameters': this.downloadDataPayload})
						data = downloadedData; //this.formatWaterQualityData(downloadedData);
					}
					else if(this.DOWNLOAD_DATATYPES[1] === this.downloadDatatype?.value)
					{
						this.monitoringService.logEvent('DownloadAnnualGradeData',{'parameters': this.downloadDataPayload})
						data = downloadedData; //this.formatAnnualGradeData(downloadedData);
					}
					downloadData(downloadedData, `${this.downloadDatatype?.value}-${new Date().getTime()}.csv`, "text/csv");
				}
				this.processing = false;
			});
		}	
		catch(ex) 
		{
			this.processing = false;
		}	
		
	}


	get isFormValid() {		

		const valid = this.downloadDatatype?.valid &&
			(
				(this.DOWNLOAD_DATATYPES[0] === this.downloadDatatype?.value && this.fromDate?.isValid() && 
					this.fromDate?.isValid() && !this.fromDateToDateError.error) ||					
				(this.DOWNLOAD_DATATYPES[1] === this.downloadDatatype?.value && this.selectedYears?.valid)
			) &&
			this.regionCouncilBeachSiteSelector?.valid;			
			

		return valid;
	}
	

	showDownloadDataConfirmDialog = () => {	
		this.showFeedbackDialog({
			data : 
			{ 
				title : "Record display limit reached",
				content : `To ensure the best experience with fast page loading, we have limited 
					the displaying of search records to 500. We recommend downloading the CSV to view 
					the complete data set of records according to the filters you have selected. Otherwise, you can adjust your filters.`,
				acceptButtonText : "Download CSV",
				cancelButtonText : "Go back",
				showCancelButton : true,
				acceptClicked : this.onDownloadDataAccepted,
				cancelClicked : this.onDownloadDataCancelled
		}});
		
	}

	private showFeedbackDialog = (data : any) => {
		this.dialogData = data;
		this.showDialog = true;
		this.userfeedbackModalDlg.openDialog(this.dialogData);
	}

	private hideFeedbackDialog = () => {	
		this.showDialog = false;
		this.dialogData = null;
		this.popupDialogRef && this.popupDialogRef.close();		
	}

	onDownloadDataAccepted = (event : any) => 
	{	
		this.hideFeedbackDialog();	
		this.onDownloadDataClicked();	
	}

	onDownloadDataCancelled  = (event : any) => {
		this.hideFeedbackDialog();
	}	
}
